/**
 * Forside-banner: reservedelsøgning sender til kollektion med ?spare_parts_q=
 */
function initBanner(root) {
  const input = root.querySelector('[data-spare-parts-banner-input]');
  const clearBtn = root.querySelector('[data-spare-parts-banner-clear]');
  const form = root.querySelector('[data-spare-parts-banner-form]');
  if (!input || !form) return;

  const syncClear = () => {
    if (clearBtn) clearBtn.hidden = input.value.length === 0;
  };

  input.addEventListener('input', syncClear);
  syncClear();

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      input.value = '';
      clearBtn.hidden = true;
      input.focus();
    });
  }

  form.addEventListener('submit', (e) => {
    if (!input.value.trim()) {
      e.preventDefault();
      input.focus();
    }
  });
}

function init() {
  document.querySelectorAll('[data-spare-parts-banner]').forEach((el) => initBanner(el));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
